import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

function UserForm({
  currentUser,
  setCurrentUser,
  handleInputChange,
  handleSubmit,
  modalMode,
  closeModal,
  error,
  availableSocietes,
}) {
  return (
    <form onSubmit={handleSubmit} className="form-field">
      {error && <div style={{ color: "red" }}>{error}</div>}
      <div className="flex">
        <div className="input-group">
          <label htmlFor="username">Nom d'utilisateur</label>
          <input
            id="username"
            type="text"
            name="username"
            value={currentUser.username}
            onChange={handleInputChange}
            required
            autoComplete="off"
          />
        </div>
        <div className="input-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            name="email"
            value={currentUser.email}
            onChange={handleInputChange}
            required
            autoComplete="email"
          />
        </div>
      </div>

      <div className="flex">
        <div className="input-group">
          <label htmlFor="first_name">Prénom</label>
          <input
            id="first_name"
            type="text"
            name="first_name"
            value={currentUser.first_name}
            onChange={handleInputChange}
            autoComplete="given-name"
          />
        </div>
        <div className="input-group">
          <label htmlFor="last_name">Nom de famille</label>
          <input
            id="last_name"
            type="text"
            name="last_name"
            value={currentUser.last_name}
            onChange={handleInputChange}
            autoComplete="family-name"
          />
        </div>
      </div>

      <div className="flex-password">
        {modalMode === "add" && (
          <div className="input-group-password">
            <label htmlFor="password">Mot de passe</label>
            <input
              id="password"
              type="password"
              name="password"
              value={currentUser.password}
              onChange={handleInputChange}
              required
              autoComplete="new-password"
            />
          </div>
        )}
        {/* <div className="input-group"> */}
         
            <label htmlFor="is_admin" className="admin">
              Admin :
              <input
                className="custom-checkbox"
                id="is_admin"
                type="checkbox"
                name="is_admin"
                checked={currentUser.is_admin}
                autoComplete="off"
                onChange={(e) =>
                  handleInputChange({
                    target: {
                      name: e.target.name,
                      value: e.target.checked,
                    },
                  })
                }
              />
            </label>
          </div>
       
      {/* </div> */}

      {modalMode === "edit" && (
        <div className="societes-scroll-container">
          <label
      htmlFor="checkboxes-tags-demo"
      className="sous-title-societe"

    >
      Sociétés associées
    </label>
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            style={{ width: 530, marginBottom: "0px"  , marginTop:"5px"}}
            options={availableSocietes}
            disableCloseOnSelect
            getOptionLabel={(option) => option.nom}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderOption={(option, { selected }) => (
              <>
                <Checkbox
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.nom} - {option.siret}
              </>
            )}
            value={currentUser.societes}
            onChange={(event, newValue) => {
              setCurrentUser((prev) => ({
                ...prev,
                societes: newValue,
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                id="Sociétés associées"
                name="Sociétés associées"
                // label="Sociétés associées"
                placeholder="Rechercher et sélectionner"
                autoComplete="off"
                 className="textfield-white"
               
              />
            )}
          />
        </div>
      )}

      <div className="form-actions">
        <button onClick={closeModal} className="cancel-button">
          Fermer
        </button>
        <button type="submit" className="submit-button">
          Sauvegarder
        </button>
      </div>
    </form>
  );
}

export default UserForm;
